import React, { useState } from "react";
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    // eslint-disable-next-line no-unused-vars
    CarouselCaption,
    // eslint-disable-next-line no-unused-vars
    Card,
    // eslint-disable-next-line no-unused-vars
    CardHeader,
    // eslint-disable-next-line no-unused-vars
    CardBody,
    // eslint-disable-next-line no-unused-vars
    CardImg,
    Col,
    CardTitle,
    CardText,
    Row,
    CardImgOverlay,
    CardLink,
} from "reactstrap";
import CarouselImage1 from "../../../assets/images/carousel/1.jpg";
import CarouselImage2 from "../../../assets/images/carousel/2.jpg";
import CarouselImage3 from "../../../assets/images/carousel/3.jpg";

const items = [
    {
        testimony: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised.`,
        name: "Sridhar",
        image: CarouselImage1,
    },
    {
        testimony: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised.`,
        name: "Srikanth",
        image: CarouselImage2,
    },
    {
        testimony: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised.`,
        name: "Haritha",
        image: CarouselImage3,
    },
];

const Testimonials = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const next = () => {
        if (animating) return;
        const nextIndex =
            activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex =
            activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = items.map((item, index) => {
        return (
            <CarouselItem
                onExiting={() => setAnimating(true)}
                onExited={() => setAnimating(false)}
                key={index}
            >
                <Card>
                    <Row noGutters>
                        <Col xs="auto">
                            <CardImg
                                style={{
                                    height: 300,
                                    width: 400,
                                    clipPath:
                                        "polygon(0 0, 0 100%, 80% 100%, 100% 0)",
                                }}
                                src={item.image}
                            />
                            <CardImgOverlay
                                style={{
                                    background: "#ffffff12",
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                }}
                            >
                                <CardTitle tag="h2">{item.name}</CardTitle>
                            </CardImgOverlay>
                            {/* <img
                style={{
                  height: 300,
                  width: 400,
                  clipPath: "polygon(0 0, 0 100%, 80% 100%, 100% 0)",
                }}
                src={item.image}
                className="img-fluid"
                alt=""
              /> */}
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div className="px-5">
                                <CardText className="f-16">
                                    {item.testimony}
                                </CardText>
                                <CardLink className="f-16 f-w-600">
                                    Read more about our kids
                                    <i className="fa fa-arrow-right"></i>
                                </CardLink>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </CarouselItem>
        );
    });

    return (
        <Carousel activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators
                items={items}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
            />
            {slides}
            <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
            />
            <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
            />
        </Carousel>
    );
};

export default Testimonials;
